import { EventEmitter } from "events";
import { AppEvent } from "./constants";

class EventService {
  constructor() {
    this.eventEmitter = new EventEmitter();
  }

  eventEmitter: EventEmitter;

  addListener = (event: AppEvent, listener: (...args: any[]) => void) => {
    this.eventEmitter.addListener(event, listener);
  };

  removeListener = (event: AppEvent, listener: (...args: any[]) => void) => {
    this.eventEmitter.removeListener(event, listener);
  };

  removeAllListeners = (event?: AppEvent) => {
    this.eventEmitter.removeAllListeners(event);
  };

  emit = (event: AppEvent, ...args: any[]) => {
    this.eventEmitter.emit(event, ...args);
  };
}

const eventService = new EventService();

export * from "./constants";
export default eventService;
